import { cn } from "../utils/cn"
import { getButtonIcon } from "../utils/buttonIcons"

type Props = {
  name?: string | null
  className?: string
}

export function IconBadge({ name, className }: Props) {
  const Icon = getButtonIcon(name)

  if (!Icon) return null

  return (
    <span className={cn("inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-white/15", className)}>
      <Icon className="h-4 w-4" aria-hidden="true" />
    </span>
  )
}
